export const SPEED_LIMIT_VALUES_ASC = [
  5, 10, 15, 20, 25, 30, 35, 40, 45, 50,
] as const;

const MIN_SPEED_LIMIT = SPEED_LIMIT_VALUES_ASC[0];
const MAX_SPEED_LIMIT =
  SPEED_LIMIT_VALUES_ASC[SPEED_LIMIT_VALUES_ASC.length - 1];

export const toNumericSpeedLimit = (value: unknown): number | null => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const getNextHigherSpeedLimit = (currentSpeedLimit: unknown): number => {
  const numericSpeedLimit = toNumericSpeedLimit(currentSpeedLimit);

  if (numericSpeedLimit === null) {
    return MIN_SPEED_LIMIT;
  }

  return (
    SPEED_LIMIT_VALUES_ASC.find(
      (speedLimit) => speedLimit > numericSpeedLimit
    ) ?? MAX_SPEED_LIMIT
  );
};

export const getNextLowerSpeedLimit = (currentSpeedLimit: unknown): number => {
  const numericSpeedLimit = toNumericSpeedLimit(currentSpeedLimit);

  if (numericSpeedLimit === null) {
    return MIN_SPEED_LIMIT;
  }

  for (let i = SPEED_LIMIT_VALUES_ASC.length - 1; i >= 0; i -= 1) {
    const speedLimit = SPEED_LIMIT_VALUES_ASC[i];
    if (speedLimit < numericSpeedLimit) {
      return speedLimit;
    }
  }

  return MIN_SPEED_LIMIT;
};
